<!--
 * @Author: zb
 * @LastEditors: l_hc
 * @Date: 2019-08-08 19:37:56
 * @LastEditTime: 2019-10-18 18:31:43
 * @Version: 1.0
 * @Description: 查看货源邀请的运力列表
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <el-dialog
    :visible.sync="viewManager.visible"
    title="邀请详情"
    width="70%"
    @close="viewManager.close"
  >
    <div v-loading="viewManager.loading" class="invitation-data">
      <div class="query-header">
        <div class="query-form">
          <el-form ref="invitationForm" :inline="true" :model="invitationForm" label-width="120px">
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item v-inputFilter class="capacity-content" label="公司名称">
                  <el-input v-model="invitationForm.companyName" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-inputFilter class="capacity-content" label="联系人">
                  <el-input v-model="invitationForm.nickName" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item class="capacity-content" label="邀请时间">
                  <el-date-picker
                    v-model="invitationForm.invitationDate"
                    :editable="false"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="operate-tool">
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="invitationFormSummit"
          >
            <i class="el-icon-search" />查询
          </el-button>
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="resetInvitationForm"
          >
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
      <div class="invitation-data-header">
        <ul>
          <li>公司名称</li>
          <li>公司地址</li>
          <li>联系人</li>
          <li>联系人电话</li>
          <li>邀请时间</li>
          <li>对方意向</li>
          <!-- <li>操作</li> -->
        </ul>
      </div>
      <div class="invitation-data-body">
        <template v-if="data.length < 1 && !viewManager.loading">
          <div class="no-data-info">
            <font>暂无匹配数据</font>
          </div>
        </template>
        <template v-for="(item, index) of data">
          <div :key="index" class="data-item">
            <ul>
              <li>{{ item.companyName }}</li>
              <li>{{ item.companyAddress }}</li>
              <li>{{ item.nickName }}</li>
              <li>{{ item.contactTel }}</li>
              <li>{{ item.createDate|_data }}</li>
              <li>{{ !Number.parseInt(item.isOffer)? '暂无回复' : Number.parseInt(item.isRejectOffer)? '已报价': '拒绝报价' }}</li>
              <!-- <li> -->
              <!-- <el-button type="text" @click="transaction">成交</el-button> -->
              <!-- <el-divider direction="vertical" />
                <el-button plain size="small" @click="showDetail(item)">
                  详情
                  <i :class="{'expand': !item.hidden}" class="el-icon-d-arrow-right" />
              </el-button>-->
              <!-- </li> -->
            </ul>
            <!-- <transportFullInfo v-if="!item.hidden" :transport="item" /> -->
          </div>
        </template>
      </div>
      <div class="invitation-data-pagination">
        <el-pagination
          :current-page="invitationPagination.pageNo"
          :total="invitationPagination.total"
          :page-size="invitationPagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="invitationChangeCurrent"
          @size-change="invitationChangeSize"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import mixinsFunction from '@/utils/mixinsFunction'
import { Page } from '@/utils/commonDataModel'
import { findTransportList } from '@/api/personal/find/goodsInvitation'
import { goodsTransaction } from '@/api/personal/find/goodsManager'
import { formatTime } from '@/shared/filters/formatTimeFilter'
export default {
  name: 'GoodsInvitation',
  mixins: [mixinsFunction],
  props: {
    id: {
      type: [String],
      default: () => ''
    }
  },
  data: function() {
    return {
      invitationForm: {
        companyName: '',
        nickName: '',
        invitationDate: ''
      },
      // 邀请列表表格分页
      invitationPagination: new Page(),
      data: [],
      goodsId: ''
    }
  },
  methods: {
    async open(goodsId) {
      this.viewManager.visible = true
      this.goodsId = goodsId
      await this.loadData()
    },
    transaction(item) {
      const params = ''
      goodsTransaction(params)
        .then(data => {})
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    // 显示详情
    showDetail(item) {
      if (item.hidden) {
        // 把展开的关闭
        this.data.forEach(item => {
          item.hidden = true
        })
      }
      item.hidden = !item.hidden
    },
    invitationChangeSize(size) {
      this.invitationPagination.pageSize = size
      this.loadData()
    },
    invitationChangeCurrent(current) {
      this.invitationPagination.pageNo = current
      this.loadData()
    },
    invitationFormSummit() {
      this.loadData()
    },
    resetInvitationForm() {
      this.cleanModal(this.invitationForm)
      this.loadData()
      //   this.$refs['invitationForm'].resetFields()
    },
    loadData() {
      this.viewManager.loading = true
      const param = this.exchangeParams(this.invitationForm)
      return findTransportList(
        this.invitationPagination,
        Object.assign({}, param, { goodsId: this.goodsId })
      )
        .then(data => {
          this.data = data.result.rows.map(item => {
            if (!item.hasOwnProperty('hidden')) {
              item.hidden = true
              item.selection = false
            }
            return item
          })
          this.invitationPagination.total = data.result.total
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    exchangeParams(params) {
      const submitHandle = {
        get(target, key, proxy) {
          if (key === 'invitationDate') {
            for (const item in target[key]) {
              target[key][item] = formatTime(
                target[key][item],
                'YYYY-MM-DD HH:mm:ss'
              )
            }
            return target[key]
          }
          return target[key]
        }
      }

      let p = {}
      if (window && window.Proxy) {
        p = new Proxy(params, submitHandle)
      } else {
        for (const key in params) {
          p[key] = submitHandle.get(params, key)
        }
      }

      if (p.invitationDate) {
        p['beginCreateDate'] = p.invitationDate[0]
        p['endCreateDate'] = p.invitationDate[1]
      }
      const temp = Object.assign({}, p)
      delete temp.invitationDate
      return temp
    }
  }
}
</script>

<style lang="scss" scoped>
$main-color: #be2316;

.invitation-data {
  /deep/.el-form-item__label:after {
    content: " :";
  }

  .query-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f1f1f1;
    .query-form {
      flex-basis: 78%;
      /deep/.el-form-item {
        width: 100%;
      }
      /deep/.el-form--inline .el-form-item__content {
        width: calc(100% - 120px);
      }
      /deep/.el-date-editor--datetimerange.el-input__inner {
        width: initial !important;
      }
    }
    .operate-tool {
      flex-basis: 20%;
      justify-content: space-around;
      display: flex;
    }
  }

  .invitation-data-header {
    color: $main-color;
    font-weight: bold;
    background-color: #ffffff;
    height: 51px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
    border-radius: 4px;
    ul {
      display: flex;
      flex-wrap: nowrap;
      line-height: 51px;
      // width: calc(100% - 16px);
      // padding: 8px 8px;
      box-sizing: content-box;
      li {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 15px;
        min-width: 50px;
        height: 100%;
        line-height: 51px;
        text-align: center;
        &:nth-child(1) {
          flex-basis: 20%;
        }
        &:nth-child(2) {
          flex-basis: 20%;
        }
        &:nth-child(3) {
          flex-basis: 20%;
        }
        &:nth-child(4) {
          flex-basis: 20%;
        }
        &:nth-child(5) {
          flex-basis: 16%;
        }
        &:last-child {
          flex-basis: 20%;
        }
      }
    }
  }
  .invitation-data-body {
    position: relative;
    // min-height: 910px;
    background-color: #f5f5f5;
    .no-data-info {
      background-color: #fff;
      width: 100%;
      text-align: center;
      margin-top: 8px;
      height: 51px;
      line-height: 48px;
      font-size: 15px;
    }
    // .no-data-info {
    //   background-color: #fff;
    //   width: 100%;
    //   text-align: center;
    //   margin-top: 8px;
    //   height: 48px;
    //   line-height: 48px;
    //   font-size: 15px;
    // }
    .data-item {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
      border-radius: 4px;
      margin: 8px 0px;
      // border: 1px solid #ebeef5;
      position: relative;
      box-sizing: border-box;
      ul {
        display: flex;
        flex-wrap: nowrap;
        height: 51px;
        // width: calc(100% - 16px);
        // padding: 8px 8px;
        position: relative;
        background-color: white;
        color: rgba(51, 51, 51, 1);
         *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
        li {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 15px;
          min-width: 50px;
          height: 100%;
          line-height: 51px;
          text-align: center;

          &:nth-child(1) {
            flex-basis: 20%;
          }
          &:nth-child(2) {
            flex-basis: 20%;
          }
          &:nth-child(3) {
            flex-basis: 20%;
          }
          &:nth-child(4) {
            flex-basis: 20%;
          }
          &:nth-child(5) {
            flex-basis: 16%;
          }
          &:last-child {
            flex-basis: 20%;
            /deep/ .el-button.is-plain {
              background-color: white;
              color: #be2316;
              border-color: #be2316;
              padding: 7px 4px !important;
              width: 56px;
              span > i {
                transition: 0.5s all;
                transform: rotateZ(90deg);
                &.expand {
                  transform: rotateZ(-90deg);
                }
              }
            }
          }
        }
      }
      /deep/ .goods-item-details {
        border: 1px solid #ebeef5;
        z-index: 0;
      }
    }
  }
  .invitation-data-pagination {
    margin-top: 24px;
    padding: 16px 0px;
    background-color: white;
  }
}
</style>
